'use client'

import { useTokenStore } from '@/core/services/tokens/memory-token.service'
import { UserDetailsModel } from '@/features/auth/types/models/user-details.model'
import { UserMessagesModel } from '@/features/auth/types/models/user.model'
import { useInitNotifications } from '@/features/notifications/hooks/use-init-notifications'
import { useObserveNotifications } from '@/features/notifications/hooks/use-observer-notifications'
import { useEffect } from 'react'
import { useAuth } from '.'

type Props = {
  user: UserDetailsModel | null
  messages?: UserMessagesModel[]
  accessToken: string | null
}

export function AuthSetter({ user, messages, accessToken }: Props) {
  const { clearUser, setUser, isAuthenticated } = useAuth()
  const { setToken, clearToken } = useTokenStore()

  const initNotifications = useInitNotifications()
  useObserveNotifications()

  useEffect(() => {
    if (!user) {
      clearUser()
    } else {
      setUser(user, messages)
    }
  }, [user, messages, clearUser, setUser])

  useEffect(() => {
    if (accessToken) setToken(accessToken)
    else clearToken()
  }, [accessToken, clearToken, setToken])

  useEffect(() => {
    if (isAuthenticated) initNotifications()
  }, [initNotifications, isAuthenticated])

  return null
}
